import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import ArcoVue from '@arco-design/web-vue'
import '@arco-design/web-vue/dist/arco.css'
import router from './router'
import i18n from './locales'
import App from './App.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { debugI18n } from './utils/debugI18n'

// 原版CSS已经在index.html中引入，这里只需要Vue 3的补充样式
import './styles/vue3-additions.scss'

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

// 使用插件
app.use(head)
app.use(pinia)
app.use(router)
app.use(ArcoVue)

// 添加错误处理
console.log('=== main.js 执行 ===')
console.log('准备注册i18n插件...')

try {
  app.use(i18n)
  console.log('✓ i18n插件注册成功')
  
  // 运行i18n诊断
  try {
    console.log('开始i18n诊断...')
    debugI18n(i18n)
  } catch (diagError) {
    console.error('诊断过程出错:', diagError)
  }
  
  // 测试i18n是否工作
  if (i18n.global && i18n.global.t) {
    try {
      const testKey = 'footer.support247'
      const testResult = i18n.global.t(testKey)
      console.log(`测试翻译 '${testKey}':`, testResult)
    } catch (e) {
      console.error('测试翻译失败:', e)
    }
  }
} catch (error) {
  console.error('!!! i18n初始化错误:', error)
  console.error('错误详情:', error.message)
  console.error('错误栈:', error.stack)
}

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('=== Vue全局错误 ===')
  console.error('错误消息:', err.message)
  console.error('错误位置:', info)
  console.error('组件实例:', instance?.$options?.name || '未知')
  
  // 特别处理i18n错误
  if (err.message && err.message.includes('linked format')) {
    console.error('!!! 发现i18n链接格式错误 !!!')
    console.error('完整错误:', err)
    
    // 尝试找出问题的key
    if (err.stack) {
      const stackLines = err.stack.split('\n')
      console.error('错误栈详情:')
      stackLines.forEach(line => {
        if (line.includes('message-compiler') || line.includes('parseLinked')) {
          console.error('  关键行:', line)
        }
      })
    }
    
    // 在生产环境下继续运行
    if (import.meta.env.PROD) {
      console.warn('生产环境 - 忽略i18n错误继续运行')
      return false // 阻止错误传播
    }
  }
  
  return null // 默认行为
}

// 挂载应用
app.mount('#app')

// 初始化 AOS 动画库
AOS.init({
  duration: 300,
  once: true
})